import { render, staticRenderFns } from "./EditAccessrule.vue?vue&type=template&id=17923ef2&scoped=true&"
import script from "./EditAccessrule.vue?vue&type=script&lang=js&"
export * from "./EditAccessrule.vue?vue&type=script&lang=js&"
import style0 from "./EditAccessrule.vue?vue&type=style&index=0&id=17923ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17923ef2",
  null
  
)

export default component.exports